/**
 * @generated SignedSource<<cef320d3e7e3f07925eea489c563e9b0>>
 * @relayHash bcacc4aa39348a241356e4b97f573846
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6c89ce31b20d689e2ae0463f90575551a32d655a55d27ab0f50823267552bf46

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type HelpCenterPageUpdateInput = {
  description?: string | null | undefined;
  helpCenterPageAri: string;
  name: string;
  pageLayout?: HelpCenterPageLayoutInput | null | undefined;
};
export type HelpCenterPageLayoutInput = {
  layoutAdf?: string | null | undefined;
  metadata?: string | null | undefined;
};
export type actionBarUpdatePageMutation$variables = {
  cloudId: string;
  input: HelpCenterPageUpdateInput;
};
export type actionBarUpdatePageMutation$data = {
  readonly helpCenter: {
    readonly updateHelpCenterPage: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type actionBarUpdatePageMutation = {
  response: actionBarUpdatePageMutation$data;
  variables: actionBarUpdatePageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "HelpCenterMutationApi",
    "kind": "LinkedField",
    "name": "helpCenter",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "HelpCenterPageUpdatePayload",
        "kind": "LinkedField",
        "name": "updateHelpCenterPage",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "actionBarUpdatePageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "actionBarUpdatePageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "6c89ce31b20d689e2ae0463f90575551a32d655a55d27ab0f50823267552bf46",
    "metadata": {},
    "name": "actionBarUpdatePageMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a4b4d00378b1ecff01d2b5a91dd0ddaa";

export default node;
